import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_109: FaireProductEntity = {
  token: "starter_collection_109",
  type: "product",
  name: "Wilson Keyring",
  brandName: "Craighill",
  imageUrl:
    '"https://cdn.faire.com/fastly/5af62e01183c65a91468382f122214ab6e8f89c6fff0f1046da57d5677c6f1bf.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1208',
  priceDollars: 32,
  msrpDollars: 64,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
